import agent from './agent';
import config from '../config.json';
import ServiceBase from './ServiceBase';

const baseUrl = config.baseUrl;
const service = 'JernyGateway'.toLowerCase();

class GatewayService extends ServiceBase {
    /**
     * Returns current user from BE.
     * @returns {Promise}
     */
    getUserTypes = () => {
        const url = `${baseUrl}/${service}/user/types`;
        const config = { headers: { Authorization: `Bearer ${this.getToken()}` } };
        return agent.get(url, config);
    };

    /**
     * Returns current user from BE.
     * @returns {Promise}
     */
    getUser = () => {
        const url = `${baseUrl}/${service}/user/me`;
        const config = { headers: { Authorization: `Bearer ${this.getToken()}` } };
        return agent.get(url, config);
    };

    /**
     * Returns paged entries for a topic.
     * @param {string} topic
     * @param {number} page
     * @param {number} size
     * @returns {Promise}
     */
    getUserEntries = (topic, page, size, type) => {
        const token = this.getToken();
        const url = `${baseUrl}/${service}/user/entries?rk=${topic}&page=${page}&size=${size}&type=${type}`;
        const config = { headers: { Authorization: `Bearer ${token}` } };
        return agent.get(url, config);
    };

    /**
     * Returns project refs for a project.
     * @param {string} project
     * @returns {Promise}
     */
    getProjectRefs = (project) => {
        const url = `${baseUrl}/${service}/project/refs?project=${project}`;
        const config = { headers: { Authorization: `Bearer ${this.getToken()}` } };
        return agent.get(url, config);
    };

    /**
     * Activates user after Clerk signup.
     * @param {string} uid
     * @param {string} tier
     * @returns {Promise}
     */
    activateUser = (uid, tier) => {
        const url = `${baseUrl}/${service}/user/activate`;
        const config = {
            headers: {
                Authorization: `Bearer ${this.getToken()}`,
                'Content-Type': 'application/json',
            },
        };
        return agent.post(url, { uid, tier }, config);
    };

    /**
     * Posts priority update.
     * @param {object} data
     * @returns {Promise}
     */
    postPrioUpdate = (data) => {
        const url = `${baseUrl}/${service}/user/prio`;
        const config = {
            headers: {
                Authorization: `Bearer ${this.getToken()}`,
                'Content-Type': 'application/json',
            },
        };
        return agent.post(url, { data }, config);
    };
}

const gatewayService = new GatewayService();
export default gatewayService;
